import WorkOrderExecutionHoldTime from '@/models/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTime';

export default class WorkOrderExecutionHoldTimeFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderExecutionId  = '';
		this.workOrderExecutionShift = '';
		this.startTimeFrom = '';
		this.startTimeTo = '';
		this.remarkMultiple = '';
		this.endTimeFrom = '';
		this.endTimeTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderExecutionId : '0',
			workOrderExecutionShift : '0',
			startTimeFrom : '0',
			startTimeTo : '0',
			remarkMultiple : '0',
			endTimeFrom : '0',
			endTimeTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}